import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, Modal, Popover, message } from 'antd';
import OperationLog from '../../contractManagement/contractRecord/components/OperationLog';
import ProjectRequestFinish from '../../contractManagement/contractRecord/components/ProjectRequestFinish';
import ContractRequestFinish from '../../contractManagement/contractRecord/components/ContractRequestFinish';
import LookAttachment from '../../contractManagement/contractRecord/components/LookAttachment';
import ExportFixedLine from '../../contractManagement/contractRecord/components/ExportFixedLine';
import $ from '../../../common/AjaxRequest';
import ExportUtil from '../../../common/ExportUtil';
import TableC from '../../basicElement/TableC';
import API_URL from '../../../common/url';
import cellRenderEnhancer, { beforeChangeEnhancer } from '../../shared/cellRenderEnhancer';
import format from '../../shared/format';
import SideNav from '../SideNav';
import Filter from './Filter';
import { saveParams } from '../../../actions/noticeActions';
import { queryInvestigationStage } from '../../common/queryInvestigationStage';

class ContractRecord extends Component {
    constructor(props) {
        super(props);
        this.queryInvestigationStage = queryInvestigationStage.bind(this);
        const { path, jdeCode } = props;
        const searchParams = {
            jdeContractAmountSymbol: 'Equals',
            startTimeSymbol: 'Equals',
            endTimeSymbol: 'Equals',
        };
        if (path === '/projectContract/contractRecord') {
            searchParams.jdeCode = jdeCode;
        }
        this.state = {
            searchParams,
            pagination: {
                pageSize: 10,
                current: 1,
            },
            data: [],
            invConfirm: {},
            loading: false,
            contractRequestFinish: false,
            PmContractRequestFinish: false,
        };
    }

    componentDidMount() {
        this.loadData();
        this.queryInvestigationStageByInvId();
    }

    componentWillUnmount() {
        const { saveParams } = this.props;
        saveParams({
            path: undefined,
            jdeCode: undefined,
        });
    }

    loadData = () => {
        const { searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.listJdeContractSite,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { invName, curRole } = sessionStorage;
                const { datas: { datas, totalCount }, invCanApplyCompleted, invRemittanceCompletedInfoShow, ...invConfirm} = res;
                pagination.total = totalCount;
                (datas || []).forEach(i => i.investigationName = invName);
                const contractRequestFinish = invCanApplyCompleted == '1' && (invRemittanceCompletedInfoShow === '未确认' || invRemittanceCompletedInfoShow === 'PM拒绝确认' || invRemittanceCompletedInfoShow === 'FIN拒绝确认');
                const PmContractRequestFinish = curRole === 'PM' && invRemittanceCompletedInfoShow === '待PM确认';
                this.setState({
                    contractRequestFinish,
                    PmContractRequestFinish,
                    loading: false,
                    data: datas,
                    pagination,
                    invConfirm,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (params) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: {...params},
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { searchParams, pagination } = this.state;
        const url = API_URL.investigation.exportJdeContractSite;
        ExportUtil.export(searchParams, pagination, url);
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            },
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'TERMINATED_BEFORE_CONTRACT') {
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    getColumns = () => {
        const { invConfirm: { pmConfirmUserName, pmConfirmEmployeeCode, finConfirmUserName, finConfirmEmployeeCode } } = this.state;
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 60,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'mainInvestigationJdeContractCode',
            key: 'mainInvestigationJdeContractCode',
            fixed: 'left',
            width: 100,
        }, {
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            fixed: 'left',
            width: 120,
            render: (value, row, index) => {
                const { fileCount } = row;
                if (fileCount != null) {
                    return <span>{value}<Icon type="paper-clip" style={{ color: '#ffbf00', cursor: 'pointer' }} onClick={() => this.showAttachment(row,'investigationJdeContractCode')} /></span>;
                }
                return value;
            },
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineNames',
            key: 'secondLineNames',
            width: 100,
        }, {
            title: '类别码13',
            dataIndex: 'categoryCodeName13',
            key: 'categoryCodeName13',
            width: 80,
            render: (value, row, index) => {
                return value ? <span style={{ color: row.categoryCodeStatus == 1 && 'red' }}>{value}</span> : '';
            },
        }, {
            title: '合同签署单位',
            dataIndex: 'signingUnit',
            key: 'signingUnit',
            width: 100,
        }, {
            title: '收入归属单位',
            dataIndex: 'belongingToUnit',
            key: 'belongingToUnit',
            width: 100,
        }, {
            title: '客户全名',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 100,
        }, {
            title: '客户JDE号',
            dataIndex: 'customerJdeCode',
            key: 'customerJdeCode',
            width: 100,
        }, 
        // {
        //     title: 'BA工号',
        //     dataIndex: 'baCode',
        //     key: 'baCode',
        //     width: 80,
        // }, 
        {
            title: '合同BA',
            dataIndex: 'baName',
            key: 'baName',
            width: 80,
            render: (text, record) => {
                return record.baWorkStatus == 'LEFT' ? <span style={{ color: '#999999' }}>{text}</span> : text; 
            },
        }, 
        {
            title: '客户BA',
            dataIndex: 'baNameCode',
            key: 'baNameCode',
            width: 80,
            render: (text, record) => {
                return (
                    (record.baList || []).map((item, index, arr) => {
                        const { userId, employeeCode, userCompellation, workStatus } = item;
                        return <span key={userId} style={{ color:workStatus == 'LEFT'?'#999999':undefined }}>{userCompellation}[{employeeCode}]{index < arr.length - 1 && '；'}{(index + 1) % 2 === 0 && <br />}</span>;
                    })
                )
            }
        }, 
        {
            title: '客户CSA',
            dataIndex: 'csaNameCode',
            key: 'csaNameCode',
            width: 120,
            render: (text, record) => {
                return (
                    (record.csaList || []).map((item, index, arr) => {
                        const { userId, employeeCode, userCompellation, workStatus } = item;
                        return <span key={userId} style={{ color:workStatus == 'LEFT'?'#999999':undefined }}>{userCompellation}[{employeeCode}]{index < arr.length - 1 && '；'}{(index + 1) % 2 === 0 && <br />}</span>;
                    })
                )
            }
        }, 
        {
            title: '名称(ProjectID)',
            dataIndex: 'projectIdName',
            key: 'projectIdName',
            width: 100,
        }, {
            title: '计收入确认方式',
            dataIndex: 'contractTypeValue',
            key: 'contractTypeValue',
            width: 80,
            render: cellRenderEnhancer({
                renderContent: beforeChangeEnhancer((record) => record['oldContractTypeValue'])
           })(),
        }, {
            title: '发票税率',
            dataIndex: 'invoiceRate',
            key: 'invoiceRate',
            width: 70,
            render: value => format('unit', value, '%'),
        },{
            title: '是否据实结算',
            dataIndex: 'isRealitySettle',
            key: 'isRealitySettle',
            width: 100,
            render:text => text==1?'是':text==0?'否':''
        },{
            title: '客户是否MSA特殊优惠客户',
            dataIndex: 'isMsaSpecialDiscountCustom',
            key: 'isMsaSpecialDiscountCustom',
            width: 100,
            render:text => text==1?'是':text==0?'否':''
        },{
            title: '是否在优惠有效期内',
            dataIndex: 'isDiscountTermValidity',
            key: 'isDiscountTermValidity',
            width: 100,
            render:text => text==1?'是':text==0?'否':''
        },{
            title: 'MSA特殊优惠是否从合同额中扣减',
            dataIndex: 'isMsaSpecialContractReduce',
            key: 'isMsaSpecialContractReduce',
            width: 100,
            render:text => text==1?'是':text==0?'否':''
        },{
            title: '优惠金额（含税）/人民币',
            dataIndex: 'discountContractAmount',
            key: 'discountContractAmount',
            width: 100,
        },{
            title: '优惠金额（不含税）/人民币',
            dataIndex: 'discountContractAmountNoTax',
            key: 'discountContractAmountNoTax',
            width: 100,
        }, {
            title: '合同是否签署完成',
            dataIndex: 'investigationJdeContractIsSigned',
            key: 'investigationJdeContractIsSigned',
            width: 80,
            render: (value, row, index) => {
                const { investigationJdeContractIsSigned } = row;
                if (investigationJdeContractIsSigned == '0') {
                    return '否';
                } else if (investigationJdeContractIsSigned == '1') {
                    return '是';
                }
                return value;
            },
        }, {
            title: '合同中是否明标合同金额',
            dataIndex: 'investigationJdeContractIsSpecifiesAmount',
            key: 'investigationJdeContractIsSpecifiesAmount',
            width: 90,
            render: (value, row, index) => {
                const { investigationJdeContractIsSpecifiesAmount } = row;
                if (investigationJdeContractIsSpecifiesAmount === '0') {
                    return '否';
                } else if (investigationJdeContractIsSpecifiesAmount === '1') {
                    return '是';
                }
                return value;
            },
        }, {
            title: '币种',
            dataIndex: 'currency',
            key: 'currency',
            width: 90,
        }, {
            title: '汇率',
            dataIndex: 'exchangeRate',
            key: 'exchangeRate',
            width: 90,
        }, {
            title: '合同额含税/原币',
            dataIndex: 'initialContractAmount',
            key: 'initialContractAmount',
            width: 110,
            render: (value, row) => {
                const { initialActualExpenseFee, initialTaxationFee, initialActualFee } = row;
                if (initialActualExpenseFee || initialActualExpenseFee === 0 || initialActualFee || initialActualFee === 0 || initialTaxationFee || initialTaxationFee === 0) {
                    return (
                        <div>
                            <Popover
                                placement="right"
                                overlayClassName="gray-pop"
                                content={<div>
                                    {(initialActualExpenseFee || initialActualExpenseFee === 0) && <span>{`实报实销(不含税)/原币: ${format('money', initialActualExpenseFee)}`}<br/></span>}
                                    {(initialActualFee || initialActualFee === 0) && <span>{`实报实销税费/原币: ${format('money', initialActualFee)}`}<br/></span>}
                                    {(initialTaxationFee || initialTaxationFee === 0) && <span>{`合同额税费/原币: ${format('money', initialTaxationFee)}`}<br/></span>}
                                </div>}
                                trigger="hover"
                            >
                                <div>
                                    <i className='pop' style={{cursor: 'pointer'}}></i>
                                    {format('money', value)}
                                </div>
                            </Popover>
                        </div>
                    );
                }
                return format('money', value);
            },
        }, {
            title: '合同额含税/人民币(元)',
            dataIndex: 'jdeContractAmountShow',
            key: 'jdeContractAmountShow',
            width: 140,
            render: (value, row, index) => {
                const { actualExpenseFeeShow, taxationFeeShow, actualFeeShow } = row;
                if (actualExpenseFeeShow || actualExpenseFeeShow === 0 || taxationFeeShow || taxationFeeShow === 0 || actualFeeShow || actualFeeShow === 0) {
                   return (
                        <div>
                            <Popover
                                placement="bottomLeft"
                                overlayClassName="contract-pop"
                                content={<div>
                                    {(actualExpenseFeeShow || actualExpenseFeeShow === 0) ? <span>{`实报实销(不含税)/人民币: ${format('money', actualExpenseFeeShow)}`}<br /></span> : null}
                                    {(actualFeeShow || actualFeeShow === 0) ? <span>{`实报实销税费/人民币: ${format('money', actualFeeShow)}`}<br /></span> : null}
                                    {(taxationFeeShow || taxationFeeShow === 0) ? <span>{`合同额税费/人民币: ${format('money', taxationFeeShow)}`}<br /></span> : null}
                                </div>}
                                trigger="hover"
                            >
                                <i className="pop" style={{ cursor: 'pointer' }} />
                            </Popover>
                            <div className="pop-div">{format('money', value)}</div>
                        </div>
                    );
                }
                return format('money', value);
            },
        }, {
            title: '合同税率',
            dataIndex: 'rate',
            key: 'rate',
            width: 70,
            render: value => format('unit', value, '%'),
        }, {
            title: '合同新增时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: 90,
            render: value => format('date', value),
        }, {
            title: '合同开始时间',
            dataIndex: 'startTimeShow',
            key: 'startTimeShow',
            width: 90,
        }, {
            title: '合同结束时间',
            dataIndex: 'endTimeShow',
            key: 'endTimeShow',
            width: 90,
        }, {
            title: '合同性质',
            dataIndex: 'contractNatureShow',
            key: 'contractNatureShow',
            width: 80,
        }, {
            title: '关联JDE',
            dataIndex: 'relationContractCode',
            key: 'relationContractCode',
            width: 100,
        }, {
            title: '备注',
            dataIndex: 'comments',
            key: 'comments',
            width: 140,
        }, {
            title: '涉及中心',
            dataIndex: 'jdeSiteInfo',
            key: 'jdeSiteInfo',
            width: 120,
            render: (value, row, index) => {             
                    const {jdeSiteTips } = row;
                    const jdeSiteTipsList = jdeSiteTips?jdeSiteTips.split(';'):[]
                if ((jdeSiteTipsList || []).length > 1) {
                    return (
                        <div>
                            <Popover
                                placement="bottomRight"
                                overlayClassName="contract-pop"
                                content={
                                    <div style={{ color: '#333e4d' }} >
                                        {
                                        jdeSiteTipsList.map((value,index) => (
                                            <div key={index}>
                                                {value} 
                                            </div>
                                        ))
                                    }
                                    </div>
                                }
                                trigger="hover"
                            >
                                <i className="pop" style={{ cursor: 'pointer' }} />
                            </Popover>
                            <div className="pop-div">{this.matchKeyword(value)}...</div>
                        </div >
                    );
                } else {
                    return <div>{this.matchKeyword(value)}</div >;
                }
            },
        }, {
            title: 'FTE单价(含税)(元)',
            dataIndex: 'fteUnitPrice',
            key: 'fteUnitPrice',
            width: 140,
        }, {
            title: '项目关闭申请情况',
            dataIndex: 'invRemittanceCompletedInfoShow',
            key: 'invRemittanceCompletedInfoShow',
            width: 100,
            render: (value, row) => {
                if (value === '待FIN确认' || value === 'FIN拒绝确认' || value === 'FIN已确认') {
                    const node = (
                        <div>
                            {`PM确认: ${pmConfirmUserName}[${pmConfirmEmployeeCode}]`}
                            <br />
                            {value === 'FIN已确认' && `FIN确认: ${finConfirmUserName}[${finConfirmEmployeeCode}]`}
                        </div>
                    );
                    return (
                        <Popover placement="right" overlayClassName="contract-pop" content={node}>
                            <div>
                                <i className='pop'></i>
                                {value}
                            </div>
                        </Popover>
                    );
                }
                return value;
            },
        }];
        const { curRole } = sessionStorage;
        if (curRole === 'PM') {
            columns.push({
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                width: 180,
                render: (value, row) => {
                    const { remittanceCompletedInfoShow: status, isContrary } = row;
                    if (isContrary == 1) {
                        return '-';
                    }
                    return (
                        <span>
                            {/* {
                                (status === '待PM确认') ?
                                    <a onClick={() => this.canEditByInvStatus(() => this.applyContractFinish(row, 'PM'))}>确认合同请款完成</a>
                                :
                                    <a disabled={true}>确认合同请款完成</a>
                            }
                            <span className="ant-divider" /> */}
                            <a onClick={() => this.showOperationLog(row, 'CONTRACT_REMITTANCE_LOG')}>操作日志</a>
                        </span>
                    );
                }
            });
        }
        if (curRole === 'CSA' || curRole === 'CSAL') {
            columns.push({
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                width: 180,
                render: (value, row) => {
                    const { isContrary, isPaymentProgress, remittanceCompletedInfoShow: status } = row;
                    const canApply = isPaymentProgress == 1 && (status === '未确认' || status === 'PM拒绝确认' || status === 'FIN拒绝确认');
                    if (isContrary == 1) {
                        return '-';
                    }
                    return (
                        <span>
                            {/* {
                                <a disabled={!canApply} onClick={() => this.canEditByInvStatus(() => this.applyContractFinish(row, 'BA'))}>申请合同请款完成</a>
                            } */}
                            -
                        </span>
                    );
                }
            });
        }
        return columns;
    }

    matchKeyword = data => {
        const { keyword = '' } = this.state.searchParams;
        data = data || '';
        let newData;
        if (keyword == '' || keyword.trim() == '') {
            newData = data;
        } else {
            const result = new RegExp(keyword).exec(data);
            if (result != null) {
                const len = result[0].length;
                if (result.index == 0) {
                    newData = <span><span style={{ color: 'blue' }}>{result[0]}</span>{data.slice(len + result.index)}</span>;
                } else if (result.index > 0) {
                    newData = <span>{data.slice(0, result.index)}<span style={{ color: 'blue' }}>{result[0]}</span>{data.slice(len + result.index)}</span>;
                }
            } else {
                newData = data;
            }
        }
        return newData;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map(item => ({
            ...item,
        }));
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    showFixedLine = () => {
        this.exportFixedLineRef.show();
    }

    showAttachment = (record, type) => {
        this.showAttachmentModal.show(record, type);
    }

    showOperationLog = (record, type) => {
        this.operationLogRef.show(record, type);
    }

    applyProjectFinish = (role) => {
        const { data } = this.state;
        const record = data[0];
        const { investigationId } = record;
        this.queryInvestigationStage(investigationId, () => {
            if (role === 'BA') {
                Modal.confirm({
                    title: '确认申请此项目请款完成？',
                    content: '确认后，将通知PM和财务进行请款完成确认操作。一旦全部确认，项目阶段将变更为“项目关闭”。',
                    onOk: () => {
                        this.projectRef.show(record, role);
                    }
                });
            } else {
                this.projectRef.show(record, role);
            }
        }, ['INVESTIGATION_DATA_LOCK']);
    }

    applyContractFinish = (record, role) => {
        if (role === 'BA') {
            Modal.confirm({
                title: '确认申请此合同请款完成？',
                content: '确认后，将通知PM和财务进行请款完成确认操作。PM和财务确认此合同请款完成后，不可再为此合同进行请款。',
                onOk: () => {
                    this.canEditByInvStatus(() => this.contractRef.show(record, role));
                }
            });
        } else {
            this.canEditByInvStatus(() => this.contractRef.show(record, role));
        }
    }

    render() {
        const { loading, searchParams, pagination, contractRequestFinish, PmContractRequestFinish } = this.state;
        return (
            <div className="content">
                <SideNav selectKey="contractRecord" />
                <div className="main">
                    <Filter
                        params={searchParams}
                        export={this.export}
                        search={this.search}
                        showFixedLine={this.showFixedLine}
                        contractRequestFinish={contractRequestFinish}
                        PmContractRequestFinish={PmContractRequestFinish}
                        applyProjectFinish={this.applyProjectFinish}
                    />
                    <TableC
                        rowKey="key"
                        loading={loading}
                        data={this.getDataSource()}
                        columns={this.getColumns()}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                    <ExportFixedLine ref={el => this.exportFixedLineRef = el} />
                    <LookAttachment ref={el => this.showAttachmentModal = el} />
                    <OperationLog ref={el => this.operationLogRef = el} />
                    <ProjectRequestFinish ref={el => this.projectRef = el } loadData={this.loadData} />
                    <ContractRequestFinish ref={el => this.contractRef = el } loadData={this.loadData} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContractRecord);


// WEBPACK FOOTER //
// ./src/components/projectContract/contractRecord/index.js